"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _supplier = require("@/api/supplier/supplier");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SupplierProfile',
  data: function data() {
    return {
      isEdit: false,
      submitLoading: false,
      dataForm: {
        id: null,
        supplierName: '',
        contactPerson: '',
        contactPhone: '',
        email: '',
        province: '',
        provinceId: null,
        city: '',
        cityId: null,
        district: '',
        districtId: null,
        address: '',
        remark: '',
        status: 1,
        createTime: '',
        updateTime: ''
      },
      rules: {
        supplierName: [{
          required: true,
          message: '请输入供应商名称',
          trigger: 'blur'
        }],
        contactPerson: [{
          required: true,
          message: '请输入联系人',
          trigger: 'blur'
        }],
        contactPhone: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this = this;
      (0, _supplier.supplierInfoApi)().then(function (data) {
        if (data) {
          Object.keys(_this.dataForm).forEach(function (key) {
            if (data.hasOwnProperty(key) || data[key] !== undefined) {
              _this.dataForm[key] = data[key] !== null ? data[key] : _this.dataForm[key];
            }
          });
        }
      }).catch(function () {
        _this.$message.error('获取供应商信息失败');
      });
    },
    startEdit: function startEdit() {
      this.isEdit = true;
    },
    cancelEdit: function cancelEdit() {
      this.isEdit = false;
      this.loadData();
    },
    submitEdit: function submitEdit() {
      var _this2 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this2.submitLoading = true;
        (0, _supplier.supplierUpdateApi)(_this2.dataForm).then(function () {
          _this2.$message.success('保存成功');
          _this2.isEdit = false;
          _this2.loadData();
        }).catch(function () {
          _this2.$message.error('保存失败');
        }).finally(function () {
          _this2.submitLoading = false;
        });
      });
    }
  }
};